<div *transloco="let t" class="flex h-full flex-col">
    @if (user()) {
        <vds-header>
            <ng-container ngProjectAs="[vds-header-logo]">
                <a
                    class="rounded-xs px-8 py-4 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-hidden"
                    routerLink="/jumpboard"
                >
                    <vo-logo />
                </a>
            </ng-container>
            <div class="flex items-center gap-x-4" vds-header-actions>
                <span id="userMenuAction" class="sr-only">{{ t("userMenu") }}</span>
                <span id="userMenuLabel" class="sr-only">{{ user()?.firstName + " " + user()?.lastName }}</span>
                <div>
                    <button
                        vds-icon-button
                        aria-labelledby="userMenuAction userMenuLabel"
                        appearance="ghost"
                        mode="dark"
                        [vdsTooltip]="t('userMenu')"
                        placement="bottom"
                        [vdsMenuTriggerFor]="userMenu"
                    >
                        <vds-icon name="user-new" />
                    </button>

                    <ng-template #userMenu>
                        <vds-menu appearance="dark">
                            <button type="button" vdsMenuItem (triggered)="logout()">
                                {{ t("voTextSIGNOUT") }}
                            </button>
                        </vds-menu>
                    </ng-template>
                </div>
                @if (user(); as user) {
                    <shell-ui-language-menu
                        [language]="user.language"
                        [triggerLabel]="t('languages')"
                        (languageChange)="changeUserLanguage($event, user)"
                    />
                }
            </div>
        </vds-header>

        <div class="flex flex-col gap-y-24 overflow-y-auto p-24 sm:mx-auto sm:max-w-5xl">
            <h1 class="text-24 font-bold" [innerHTML]="t('voTextTermsHeader')"></h1>

            <ng-container *featureFlag="'vo-consent-platform'; else legacyContent">
                @if (store.termsResource.error()) {
                    <div
                        class="max-w-[400px] overflow-auto rounded-xs border border-alert-medium bg-alert-transparent p-16 text-alert-bold"
                    >
                        <div class="flex items-start gap-x-8">
                            <vds-icon class="mt-4 shrink-0" name="priority" />
                            <div class="flex flex-col gap-y-8">
                                <span class="font-semibold">{{ t("tosErrorHeader") }}</span>
                                <span>{{ t("tosErrorDescription") }}</span>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="overflow-auto rounded-xs bg-white p-16">
                        @if (store.termsResource.isLoading()) {
                            <div class="flex items-center justify-center p-16">
                                <vds-progress-spinner />
                            </div>
                        } @else if (store.termsResource.hasValue()) {
                            <vui-rich-text-container [innerHTML]="store.termsResource.value().content"></vui-rich-text-container>
                        }
                    </div>
                }
                @if (store.shouldAcceptTerms()) {
                    @if (store.error()) {
                        <vds-inline-alert appearance="error" [heading]="t('tosErrorHeader')" [message]="t('tosAcceptErrorDescription')" />
                    }
                    <vo-shell-tos-form
                        [disabled]="store.termsResource.isLoading() || store.termsResource.error()"
                        [updating]="store.updating()"
                        (termsAccepted)="store.termsResource.hasValue() && store.acceptTerms(store.termsResource.value().versionId)"
                    />
                } @else {
                    <div>
                        <a vds-button routerLink="/app/jumpboard" appearance="primary">{{ t("continue") }}</a>
                    </div>
                }
            </ng-container>

            <ng-template #legacyContent>
                @if (legacyTermsResource.error()) {
                    <div
                        class="max-w-[400px] overflow-auto rounded-xs border border-alert-medium bg-alert-transparent p-16 text-alert-bold"
                    >
                        <div class="flex items-start gap-x-8">
                            <vds-icon class="mt-4 shrink-0" name="priority" />
                            <div class="flex flex-col gap-y-8">
                                <span class="font-semibold">{{ t("tosErrorHeader") }}</span>
                                <span>{{ t("tosErrorDescription") }}</span>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="overflow-auto rounded-xs bg-white p-16">
                        @if (legacyTermsResource.isLoading()) {
                            <div class="flex items-center justify-center p-16">
                                <vds-progress-spinner />
                            </div>
                        } @else if (legacyTermsResource.hasValue()) {
                            <vui-rich-text-container [innerHTML]="legacyTermsResource.value().content"></vui-rich-text-container>
                        }
                    </div>
                }
                @if (legacyShouldAcceptTerms()) {
                    <vo-shell-tos-form
                        [disabled]="legacyTermsResource.isLoading() || legacyTermsResource.error()"
                        [updating]="updating()"
                        (termsAccepted)="legacyTermsAccepted()"
                    />
                } @else {
                    <div>
                        <a vds-button routerLink="/app/jumpboard" appearance="primary">{{ t("continue") }}</a>
                    </div>
                }
            </ng-template>
        </div>
        @if (isLoading()) {
            <div class="flex items-center justify-center p-16">
                <vds-progress-spinner />
            </div>
        }
    }
</div>
